import React, { useState, useRef, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import "./header.css";
import { Link, useNavigate } from "react-router-dom";
import { removeUserSession } from "../../utilis/Common";
import {
  get_ApiManager,
  logout_ApiManager,
  post_ApiManager,
} from "../ApiManager/ApiManager";
import swal from "sweetalert";
import moment from "moment";
import Swal from "sweetalert2";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import { usePermissions } from "../../utilis/PermissionsContext";

const NavBar = (props) => {
  const history = useNavigate();
  const ref = useRef();
  const [open, setOpen] = useState(false);
  const { hasPermission } = usePermissions();
  const [attendance, setAttendance] = useState(false);
  const [attendanceLoading, setAttendanceLoading] = useState(false);
  const [ip, setIP] = useState([null]);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (open && ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [open]);

  const handleOpen = (e) => {
    e?.preventDefault?.();
    if (!open) {
      setOpen(true);
      refreshAttendance({ showLoading: !attendance });
      return;
    }

    setOpen(false);
  };

  const refreshAttendance = ({ showLoading = true } = {}) => {
    if (showLoading) {
      setAttendanceLoading(true);
    }
    get_ApiManager(
      "",
      "attendanceCheck",
      (res) => {
        setAttendance(res.data["data"]);
        setAttendanceLoading(false);
        getip();
      },
      (err) => {
        console.log(err);
        setAttendanceLoading(false);
      },
    );
  };

  useEffect(() => {
    refreshAttendance({ showLoading: false });
  }, []);
  const logout = () => {
    swal({
      title: "Logging out",
      text: "Are you sure to log out?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        logout_ApiManager(
          () => {
            removeUserSession();
            swal({
              title: "Success!",
              text: "Logged out!!",
              type: "success",
              timer: 1000,
            });
            history("/login");
          },
          () => {
            removeUserSession();
            history("/login");
          }
        );
      }
    });
  };
  const getip = async () => {
    fetch("https://geolocation-db.com/json/")
      .then((res) => res.json())
      .then((data) => setIP(data))
      .catch((e) => console.log(e));
  };
  const isUserLate = async (data) => {
    try {
      const response = await apiUrl.get("/isUserLate", {
        params: {
          date: data.date,
          time: data.time,
          ip: data.ip,
        },
      });
      console.log("response", response);

      return response.data;
    } catch (error) {
      return false;
    }
  };

  const checkInHandler = async () => {
    const data = {
      date: moment().format("YYYY-MM-DD"),
      time: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      ip:
        ip.IPv4 +
        ", " +
        ip.city +
        ", " +
        ip.country_name +
        ", " +
        ip.country_code,
    };
    const response = await isUserLate(data);
    if (response?.late === true) {
      Swal.fire({
        title: "⚠️ Late Check-In",
        html: `
  <div style="font-size:15px; text-align:left;">
      
      <p>Please provide a reason for your late check-in:</p>

      <div style="
        background: #f8d7da;
        color: #721c24;
        padding: 15px;
        border-radius: 8px;
        margin-top: 15px;
        border: 1px solid #f5c6cb;
        text-align:center;
      ">
        <div style="font-size:14px;">You have been late</div>
        
        <div style="
          font-size:32px;
          font-weight:bold;
          margin:5px 0;
        ">
          ${response.late_count_this_month} Times
        </div>

        <div style="font-size:13px;">
          in the current month
        </div>
      </div>

      <div style="
        background: #fff3cd;
        color: #856404;
        padding: 12px;
        border-radius: 8px;
        margin-top: 12px;
        border: 1px solid #ffeeba;
      ">
        <strong>Company Policy:</strong><br>
        Salary deduction applies after <b>2 late arrivals</b>.<br>
        From the <b>3rd late</b> onward, salary will be deducted.
      </div>

    </div>
  `,
        icon: "warning",
        input: "text",
        inputPlaceholder: "Enter reason...",
        showCancelButton: false,
        confirmButtonText: "CheckIn",
        preConfirm: (reason) => {
          if (!reason) {
            Swal.showValidationMessage("Reason is required");
          } else if (!/^[A-Za-z0-9\s]+$/.test(reason)) {
            Swal.showValidationMessage("Only alpha-numeric are allowed");
          }
          return reason;
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const reason = result.value;
          CheckedIn(data, reason);
        }
      });
    } else {
      CheckedIn(data, null);
    }
  };
  const CheckedIn = async (data, reason) => {
    let url = "attendanceCheckIn";
    const payload = {
      ...data,
      reason,
    };
    post_ApiManager(
      payload,
      url,
      (res) => {
        console.log("CheckedIn", res);
        if (res.data.error) swal(" ", res.data.error, "error");
        else {
          swal("Attendance Marked", "Checked-in successfully!", "success");
        }
        refreshAttendance();
      },
      (err) => {
        console.log(err);
      },
    );
  };
  const CheckedOut = (id) => {
    let url = "attendanceCheckOut";
    const data = {
      date: moment().format("YYYY-MM-DD"),
      time: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      id: id,
    };
    console.log(data);
    post_ApiManager(
      data,
      url,
      (res) => {
        console.log("CheckedOut", res);
        if (res.data.error) swal(" ", res.data.error, "error");
        else {
          swal("Attendance Marked", "Checked-out successfully!", "success");
        }
        refreshAttendance();
        logout_ApiManager(
          () => {
            removeUserSession();
            swal({
              title: "Success!",
              text: "Logged out!!",
              type: "success",
              timer: 1000,
            });
            history("/login");
          },
          () => {
            removeUserSession();
            history("/login");
          }
        );
      },
      (err) => {
        console.log(err);
      },
    );
  };
  return (
    <li className="wrapper" ref={ref}>
      <a
        className="icon-button svg"
        href="#"
        role="button"
        onClick={handleOpen}
      >
        {props.icon}
      </a>
      {open && (
        <div className="dropDownn profile-dropdown">
          <Link
            to={{ pathname: "/my-profile" }}
            className="profile-menu-item"
            onClick={() => setOpen(false)}
          >
            <span className="profile-menu-icon">
              <FaIcons.FaUser size={14} />
            </span>
            My Profile
          </Link>
          {hasPermission("permissions_page") ? (
            <Link
              to={{ pathname: "/permissions" }}
              className="profile-menu-item"
              onClick={() => setOpen(false)}
            >
              <span className="profile-menu-icon">
                <FaIcons.FaKey size={14} />
              </span>
              Roles & access
            </Link>
          ) : null}
          {hasPermission("settings_page") ? (
            <Link
              to={{ pathname: "/main-settings" }}
              className="profile-menu-item"
              onClick={() => setOpen(false)}
            >
              <span className="profile-menu-icon">
                <FaIcons.FaCogs size={14} />
              </span>
              Settings
            </Link>
          ) : null}

          <div className="profile-menu-divider" />

          {attendanceLoading && !attendance ? (
            <div className="profile-menu-item profile-menu-item--muted">
              <span className="profile-menu-icon">
                <FaIcons.FaRetweet size={14} />
              </span>
              Updating attendance...
            </div>
          ) : attendance && attendance.in && !attendance.out ? (
            <button
              type="button"
              className="profile-menu-item profile-menu-item--action"
              onClick={() => CheckedOut(attendance.id)}
            >
              <span className="profile-menu-icon">
                <FaIcons.FaRetweet size={14} />
              </span>
              Check-Out
            </button>
          ) : (
            <button
              type="button"
              className="profile-menu-item profile-menu-item--action"
              onClick={() => checkInHandler()}
            >
              <span className="profile-menu-icon">
                <FaIcons.FaRetweet size={14} />
              </span>
              Check-In
            </button>
          )}

          <div className="profile-menu-divider" />

          <button
            type="button"
            onClick={logout}
            className="profile-menu-item profile-menu-item--logout"
          >
            <span className="profile-menu-icon">
              <FaIcons.FaSignOutAlt size={14} />
            </span>
            Logout
          </button>
        </div>
      )}
    </li>
  );
};
export default NavBar;
